export enum RegistrationSystemCode {
  InternetProductRegistration = 'DandG_IPR',
  PhotoregProductRegistration = 'DandG_PPR',
  QRCodeProductRegistration = 'DandG_QRR',
}
